export const productCardHotelsMobileConverter = (props)=>{
    const data = props.props ?? props.data ?? {};
    const { title ='' , subtitle ='' , link ={
        href: ''
    } , image ={
        src: ''
    } , price , stars , descriptions =[] , rating , icon ='' , isDeal , isBlackfriday  } = data;
    const _descriptions = descriptions?.flatMap((x)=>x.content);
    return {
        ...data,
        config: {
            isBlackfriday,
            deal: isDeal,
            icon: !!icon,
            iconName: icon,
            zone: true,
            soldOut: props.soldOut,
            literals: {
                fromCaption: price?.from,
                priceCaption: price?.caption,
                excelent: rating?.text,
                good: rating?.text,
                veryGood: rating?.text
            }
        },
        image,
        link,
        price: {
            value: price?.value,
            from: !!price?.from,
            caption: !!price?.caption
        },
        title,
        subtitle,
        rating: stars,
        descriptions: _descriptions,
        reviews: rating?.value
    };
};

//# sourceMappingURL=converter.js.map